import { createAsyncThunk } from "@reduxjs/toolkit";
import { type SurveyTemplateWithCreator } from "@fitness-app/data-models/entities/SurveyTemplate";

import { type AsyncThunkCreator } from "../../../index";
import { SURVEYS_TEMPLATES_REDUCER_NAME } from "../types";

type Payload = void;

export const fetchSurveysTemplates = createAsyncThunk<SurveyTemplateWithCreator[], Payload, AsyncThunkCreator<string>>(
  `${SURVEYS_TEMPLATES_REDUCER_NAME}/fetchSurveysTemplates`,
  async (payload, { rejectWithValue, extra: { db } }) => {
    const { data, error } = await db
      .from("survey_template")
      .select("*, creator:createdBy(id, firstName, lastName)", { count: "exact" })
      .eq("archived", false)
      .order("createdAt", { ascending: false })
      .returns<SurveyTemplateWithCreator[]>();

    if (error) {
      return rejectWithValue(error.message);
    }

    return data || [];
  },
);
